import { Pipe, PipeTransform } from '@angular/core';
import { CommonService } from '../../shared/services/common.service';
import { SCConfig } from '../../sc-config/constant/sc-config.constant';

@Pipe({
    name: 'checkSubTotalAndGrossWithParashift',
    standalone: false
})
export class CheckSubTotalAndGrossWithParashiftPipe implements PipeTransform {
    constructor(private readonly commonService: CommonService) {}

    transform(serviceData: any, isFormObject: boolean = false): unknown {
        if (isFormObject) {
            const {
                ServiceItem: { TotalAmountGross }
            } = serviceData.value;
            const subTotalWithVat = this.getSubtotalPriceIncludingVat(serviceData.value)?.toFixed(2);
            const totalAmountGross = TotalAmountGross?.toFixed(2) ?? subTotalWithVat;
            return Math.abs(totalAmountGross - subTotalWithVat);
        } else {
            let subTotalWithVat = this.getSubtotalPriceIncludingVat(serviceData)?.toFixed(2);
            const totalAmountGross = serviceData?.ServiceItem?.TotalAmountGross?.toFixed(2) ?? subTotalWithVat;
            const roundedSubTotalWithVat = this.commonService
                .floatingValueToRoundFigure(Number(subTotalWithVat), true)
                .toFixed(2);
            if (totalAmountGross === roundedSubTotalWithVat) {
                subTotalWithVat = roundedSubTotalWithVat;
            }
            return Math.abs(totalAmountGross - subTotalWithVat);
        }
    }

    getSubtotalPriceIncludingVat(serviceData) {
        let vatSet = serviceData.VatSentence;
        let subtotalPrice = serviceData.SubTotalPrice;
        if (vatSet && subtotalPrice) {
            subtotalPrice = subtotalPrice + (subtotalPrice * vatSet) / 100;
        }
        if (serviceData && serviceData.RoundsTo === SCConfig.RoundsTo[1]) {
            subtotalPrice = this.commonService.floatingValueToRoundFigure(subtotalPrice, true);
        }
        return subtotalPrice;
    }
}
